export class ZmienHasloDoSkrzynkiModel {
    haslo: string;
}